import "./extend/object.js";


let accordion = function(param) {

   let button = this;
   let panel = null, outerPanel = null;
   let acc = null;

   if (!this.classList.contains('accordion')) {
      acc = {
         create: function(param) {
            let defaults = {
               closeOtherParent: null,
               showPlus: false,
               panelTransition: 'max-height .5s ease-in',
               buttonTransition: '0.4s',
               onOpening: null,
               onClosing: null,
               onOpened: null,
               onClosed: null
            };
            this.set = Object.extend(true, defaults, param);

            if (!button.classList.contains('accordion')) {
               button.setData('accordion-object', this);
               button.classList.add("accordion");
               if (this.set.showPlus) button.classList.add('show-plus');

               outerPanel = document.createElement('div');
               outerPanel.classList.add('accordion-panel');
               panel = button.nextElementSibling;
               panel.parentNode.replaceChild(outerPanel, panel);
               outerPanel.appendChild(panel);

               outerPanel.addEventListener(transitionEndEvent, () => {
                  if (button.classList.contains('active')) {
                     if (this.set.onOpened) this.set.onOpened(button);
                  }
                  else {
                     if (this.set.onClosed) this.set.onClosed(button);
                  }
               });

               button.addEventListener("click", (event) => {
                  if (this.set.closeOtherParent) {
                     this.set.closeOtherParent.querySelectorAll('.accordion').forEach((item) => {
                        if (item !== button) item.accordion().close(true);
                     });
                  }

                  this.toggle(true);
               });
            }

         },

         open: function(withTransition) {
            button.classList.add("active");
            (this.set.onOpening || async function() {})(button, panel).then(value => {
               outerPanel.style.transition = withTransition ? this.set.panelTransition : "";
               outerPanel.style.maxHeight = outerPanel.scrollHeight + "px";
               button.classList.add("active");
               this.fireTransitionEvent(outerPanel);
            });
         },

         close: function(withTransition) {
            button.classList.remove("active");
            (this.set.onClosing || async function() {})(button, panel).then(value => {
               outerPanel.style.transition = withTransition ? this.set.panelTransition : "";
               outerPanel.style.maxHeight = null;
               button.classList.remove("active");
               this.fireTransitionEvent(outerPanel);
            });
         },

         toggle: function(withTransition) {
            //let panel = button.nextElementSibling;
            if (outerPanel.style.maxHeight) this.close(withTransition);
            else                            this.open(withTransition);
            button.classList.toggle("active");
         },

         fireTransitionEvent: function(element) {
            if (parseFloat(getComputedStyle(element).transitionDuration) == 0.0) {
               element.dispatchEvent(new Event(transitionEndEvent));
            }
         }


      };

      acc.create(param);

   }
   else {
      acc = this.getData('accordion-object');
      if (typeof param === 'string') {
         acc[param]();
      }
   }

   return acc;

};



if (!HTMLElement.accordion) {
   HTMLElement.prototype.accordion = accordion;
}

NodeList.prototype.accordion = function() {
   for (let node of this) node.accordion(...arguments);
};
